import { Box, LinkButton, DataTableColumns } from '@tq/ui-components';
import { CellProps } from 'react-table';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { ExceptionLog, ReportData } from 'types';
import { useFormatLocaleDate, StandardDateFormats } from 'config';
import { useExceptionLogsFilters } from '../hooks';
import { exceptionLogsDetailsModalState, exceptionLogsDetailsState } from 'store';

export const useExceptionLogsColumns = (): DataTableColumns<ReportData>[] => {
  const { t } = useTranslation('traffic_monitor');
  const formatLocaleDate = useFormatLocaleDate();
  const filter = useExceptionLogsFilters().find(
    (exLogFilter) => exLogFilter.name === 'exceptionLogType'
  );
  const setIsOpen = useSetRecoilState(exceptionLogsDetailsModalState);
  const setDetails = useSetRecoilState(exceptionLogsDetailsState);

  return [
    {
      accessor: 'date',
      Cell: (cellProps: { value: string }) =>
        formatLocaleDate(cellProps.value, StandardDateFormats.dateAndTime).toLowerCase(),
      disableSortBy: false,
      Header: () => t('date_time_call_header', 'Date & time'),
      width: 120,
    },
    {
      accessor: 'planningApplicationReferenceNo',
      Cell: (cellProps: { value: string }) => (
        <>
          <Box alignSelf='flex-start' marginRight={120} display='inline-flex'>
            {cellProps.value}
          </Box>
        </>
      ),
      Header: () => t('parn_header', 'Application reference number'),
      width: 150,
    },
    {
      accessor: 'exceptionLogType',
      Cell: (cellProps: { value: string }) => {
        const exceptionType = filter?.items.find((type) => type.value === cellProps.value);
        return (
          <>
            <Box alignSelf='flex-start' marginRight={20} display='inline-flex'>
              {exceptionType?.label}
            </Box>
          </>
        );
      },
      disableSortBy: false,
      Header: () => t('exception_type_header', 'Exception Type'),
      width: 120,
    },
    {
      accessor: 'message',
      Cell: (cellProps: { value: string }) => (
        <>{cellProps.value.substring(0, 80).concat('...')}</>
      ),
      disableSortBy: true,
      Header: () => t('message_header', 'Message'),
      width: 260,
    },
    {
      accessor: 'msgDetail',
      Cell: ({ row: { original } }: CellProps<ExceptionLog>) => (
        <LinkButton
          ml='auto'
          size='xs'
          variant='secondary'
          onClick={() => {
            setDetails(original);
            setIsOpen(true);
          }}
        >
          {t('view_details', 'View details')}
        </LinkButton>
      ),
      Header: () => t('detail_header', 'Details'),
      width: 60,
      disableSortBy: true,
    },
  ];
};
